










































import { Component, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { configuration } from "@/config/host.config";
import { ITelemetry } from "@/@types/servers/telemetry";
import Pm2Table from "@/components/servers/Pm2Table.vue";

@Component({
  components: { Pm2Table },
})
export default class AdministrationServers extends Vue {
  telemetry: ITelemetry | null = null;
  loading = true;
  error = "";
  polling = false;
  private pollTimer: ReturnType<typeof setInterval> | null = null;

  async fetchTelemetry(): Promise<void> {
    try {
      this.loading = true;
      this.error = "";
      const { data } = await axios.get<ITelemetry>(configuration.telemetry);
      this.telemetry = data;
    } catch (err: any) {
      this.error = err?.message || "Unknown error";
    } finally {
      this.loading = false;
    }
  }

  async onRestartProcess(identifier: string): Promise<void> {
    try {
      await axios.post(
        `${configuration.telemetryRestart}/${encodeURIComponent(identifier)}`
      );
      setTimeout(() => this.fetchTelemetry(), 1000);
    } catch {
      this.fetchTelemetry();
    }
  }

  async onStopProcess(identifier: string): Promise<void> {
    try {
      await axios.post(
        `${configuration.telemetryStop}/${encodeURIComponent(identifier)}`
      );
      setTimeout(() => this.fetchTelemetry(), 1000);
    } catch {
      this.fetchTelemetry();
    }
  }

  startPolling(): void {
    this.stopPolling();
    this.polling = true;
    this.pollTimer = setInterval(() => {
      this.fetchTelemetry();
    }, 1000);
  }

  stopPolling(): void {
    this.polling = false;
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  formatTimestamp(ts: string): string {
    try {
      const d = new Date(ts);
      return d.toLocaleTimeString();
    } catch {
      return ts;
    }
  }

  async mounted(): Promise<void> {
    await this.fetchTelemetry();
    this.startPolling();
  }

  beforeDestroy(): void {
    this.stopPolling();
  }
}
